import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const LandingPage = () => {
    const history = useHistory();

    const navigateToBudgetApp = () => {
        history.push('/budget-app');
    };

    return (
        <LandingContainer>
            <ContentWrapper>
                <LogoContainer>
                    <MonikerLogo>MONIKER</MonikerLogo>
                    <Tagline>Budget Calculator</Tagline>
                </LogoContainer>

                <Description>
                    Plan your perfect experience with our comprehensive budget calculator
                </Description>

                <LaunchButton onClick={navigateToBudgetApp}>
                    Launch Budget App
                </LaunchButton>
            </ContentWrapper>
        </LandingContainer>
    );
};

export default LandingPage;

const LandingContainer = styled.div`
    background: #000000;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow: hidden;
    box-sizing: border-box;
`;

const ContentWrapper = styled.div`
    text-align: center;
    max-width: 600px;
    animation: fadeIn 1s ease-in;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const LogoContainer = styled.div`
    margin-bottom: 48px;
`;

const MonikerLogo = styled.h1`
    font-size: 5rem;
    font-weight: 900;
    color: #fdb506;
    letter-spacing: 8px;
    margin: 0;
    text-shadow: 0 4px 8px rgba(253, 181, 6, 0.3);
    font-family: 'Arial Black', sans-serif;

    @media (max-width: 768px) {
        font-size: 3rem;
        letter-spacing: 4px;
    }
`;

const Tagline = styled.p`
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: 300;
    letter-spacing: 4px;
    margin-top: 16px;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 1rem;
        letter-spacing: 2px;
    }
`;

const Description = styled.p`
    color: #b0b0b0;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 48px;
    font-weight: 300;

    @media (max-width: 768px) {
        font-size: 1rem;
    }
`;

const LaunchButton = styled.button`
    background: linear-gradient(135deg, #fdb506 0%, #d4af37 100%);
    color: #000000;
    border: none;
    padding: 18px 48px;
    font-size: 1.2rem;
    font-weight: 700;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 2px;
    box-shadow: 0 4px 16px rgba(253, 181, 6, 0.4);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 24px rgba(253, 181, 6, 0.6);
        background: linear-gradient(135deg, #d4af37 0%, #fdb506 100%);
    }

    &:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        padding: 14px 36px;
        font-size: 1rem;
    }
`;
